module.exports = __webpack_public_path__ + "static/media/banner-photo360@3x.9f658601.jpg";